import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const ServicesCard = ({ heading, description, src, serviceId }) => {
  return (
    <motion.div
      whileHover={{
        y: -4,
        boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)"
      }}
      whileTap={{ scale: 0.98 }}
      className="w-full max-w-md bg-white rounded-xl p-6 border border-gray-200 hover:border-gray-300 transition-all duration-200 shadow-sm hover:shadow-md h-64 flex flex-col"
    >
      <div className="space-y-4 flex-1 overflow-hidden">
        <h3 className="text-2xl font-bold text-gray-800 line-clamp-2">
          {heading}
        </h3>

        <p className="text-gray-600 text-md leading-relaxed line-clamp-3">
          {description}
        </p>
      </div>

      <Link
        to={`/services/${serviceId}`}
        className="inline-flex items-center text-blue-600 hover:text-blue-800 text-lg font-medium transition-colors duration-200 group mt-auto"
      >
        Learn more
        <span className="ml-2 group-hover:translate-x-1 transition-transform duration-200">
          →
        </span>
      </Link>
    </motion.div>
  );
};

export default ServicesCard;